import React, { useState, useEffect } from "react";
import { FiChevronRight, FiArrowLeft } from "react-icons/fi";
import { useIntl } from "react-intl";
import { CopyToClipboard, toAbsoluteUrl } from "../../../utils/CommonHelper";
import { useAuth } from "../../auth/components/AuthInit";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import * as actions from "../redux/SettingAction";
import Skeleton from "react-loading-skeleton";
import SweetAlert2 from "react-sweetalert2";
import { Button, Drawer, Dialog } from "@mui/material";
import { mbChangelanguage } from "../redux/SettingCRUD";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import CryptoJS from "crypto-js";

export const Setting = ({}) => {
  const dispatch = useDispatch();
  const { logout } = useAuth();
  const intl = useIntl();
  const [openLanguage, setOpenLanguage] = useState(false);
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const [swalProps, setSwalProps] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [redirectAgent, setRedirectAgent] = useState("");
  const handleClose = () => {
    setOpen(false);
  };
  const handlNew = () => {
    window.open(redirectAgent);
    setOpen(false);
  };
  const toggleDialog = () => {
    setShowDialog(!showDialog);
  };
  useEffect(() => {
    dispatch(actions.getProfile());
  }, []);

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const _showLanguage = () => {
    setOpenLanguage(true);
  };

  const handleCloseLanguage = () => {
    setOpenLanguage(false);
  };

  const handleLogout = async () => {
    if (
      sessionStorage.getItem("platform") === "mobile" ||
      sessionStorage.getItem("platform") === "telegram"
    ) {
      console.log("press:logout");
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key !== "platform" && key !== "telegramID") {
          sessionStorage.removeItem(key);
          i--;
        }
      }
      localStorage.clear();
      window.location.reload();
    } else {
      await logout();
    }
  };

  const handleDepositClick = () => {
    navigate("/setting/deposit", { state: { backTo: "/setting/profile" } });
  };
  const handleWithdrawClick = () => {
    navigate("/setting/withdraw", { state: { backTo: "/setting/profile" } });
  };
  const handleTransferClick = () => {
    navigate("/setting/transfer", { state: { backTo: "/setting/profile" } });
  };
  const handleMemberTransferClick = () => {
    navigate("/setting/memberTransfer");
  };
  const encryptData = (originalData) => {
    return CryptoJS.AES.encrypt(originalData, "279rc#!@279rc").toString();
  };
  const handleRedirectToAgent = () => {
    dispatch(actions.getAgentUsename()).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setRedirectAgent(
          `https://agent.279rc.com/?credential=${encodeURIComponent(
            btoa(encryptData(JSON.stringify(resp)))
          )}`
        );
        if (sessionStorage.getItem("platform") === "mobile") {
          console.log(
            `openurl: https://agent.279rc.com/?credential=${encodeURIComponent(
              btoa(encryptData(JSON.stringify(resp)))
            )}`
          );
        } else {
          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari || sessionStorage.getItem("platform") === "telegram") {
            setOpen(true);
          } else {
            window.open(
              `https://agent.279rc.com/?credential=${encodeURIComponent(
                btoa(encryptData(JSON.stringify(resp)))
              )}`
            );
          }
        }
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };
  const handlePersonalClick = () => {
    navigate("/setting/personal");
  };
  const handlePointShopClick = () => {
    toggleDialog();
    // navigate("/setting/pointShop");
  };
  const handleBonusClick = () => {
    navigate("/setting/bonus");
  };
  const handleReferralClick = () => {
    navigate("/setting/referral");
  };
  const handleReportClick = () => {
    navigate("/setting/report", { state: { backTo: "/setting/profile" } });
  };
  const handleTeamClick = () => {
    navigate("/setting/team");
  };
  // const handleContactUsClick = () => {
  // };

  const handleLanguageChange = (language) => {
    mbChangelanguage({
      memberid: auth.memberid,
      loginid: auth.loginid,
      databasename: auth.databasename,
      language: language,
    }).then((resp) => {
      if (resp && resp.data) {
        if (sessionStorage.getItem("platform") === "mobile") {
          console.log("update:language");
          localStorage.setItem("locale", language);
          // window.location.reload();
          handleCloseLanguage();
        } else {
          localStorage.setItem("locale", language);
          window.location.reload();
          handleCloseLanguage();
        }
      }
    });
  };

  const handleAddBankClick = () => {
    navigate("/setting/addbank");
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        backgroundImage: `url(${process.env.PUBLIC_URL}/image/homebackground.avif)`,
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "7.5vh",
      }}
    >
      <div style={{ height: "10px" }}></div>
      <SweetAlert2
        onResolve={() => {
          setSwalProps({});
        }}
        backdrop={false}
        {...swalProps}
        customClass="custom-swal"
      />
      <div style={{ display: "flex", justifyContent: "center" }}>
        {settingState.profile ? (
          <div className="mb-3" style={{ marginTop: "10px" }}>
            <QRCode
              value={settingState.profile.webmobileinvitelink}
              size={150}
              bgColor="#1c1e23"
              fgColor="#fff"
            />
          </div>
        ) : (
          <Skeleton className="w-100" height="50px" />
        )}
      </div>
      <div className="d-flex flex-column align-items-center pb-2">
        <div
          style={{
            width: "70%",
            display: "flex",
            justifyContent: "center",
            color: "white",
          }}
        >
          {settingState.profile && (
            <div
              className="d-flex align-items-center mb-2"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                className="text-nowrap text-font2 me-1"
                style={{ color: "white" }}
              >
                Web :
              </div>
              <marquee
                behavior="scroll"
                direction="left"
                style={{ color: "white" }}
              >
                <div className="pe-3 text-font2">
                  {settingState.profile.webmobileinvitelink}
                </div>
              </marquee>
              <i
                className="ms-2 fa fa-copy cursor-pointer"
                style={{ color: "white" }}
                onClick={() => {
                  if (sessionStorage.getItem("platform") === "mobile") {
                    console.log(
                      `clipboard: ${settingState.profile.webmobileinvitelink}`
                    );
                    CopyToClipboard(
                      `${settingState.profile.webmobileinvitelink}`,
                      setSwalProps,
                      intl
                    );
                  } else {
                    CopyToClipboard(
                      `${settingState.profile.webmobileinvitelink}`,
                      setSwalProps,
                      intl
                    );
                  }
                }}
              />
            </div>
          )}
        </div>
        <div
          className="mb-2"
          style={{ border: "1px solid #2e323a", width: "80%" }}
        ></div>
        {settingState.profile && settingState.profile.referralcode && (
          <div
            className="d-flex align-items-center"
            style={{ width: "70%", display: "flex", justifyContent: "center" }}
          >
            <div
              className="text-nowrap text-font2 me-1"
              style={{ color: "white" }}
            >
              Telegram :
            </div>
            <marquee
              behavior="scroll"
              direction="left"
              style={{ color: "white" }}
            >
              <div className="pe-3 text-font2">
                {settingState.profile.telegraminvitelink}
              </div>
            </marquee>
            <i
              className="ms-2 fa fa-copy cursor-pointer"
              style={{ color: "white" }}
              onClick={() => {
                if (sessionStorage.getItem("platform") === "mobile") {
                  console.log(
                    `clipboard: ${settingState.profile.telegraminvitelink}`
                  );
                  CopyToClipboard(
                    `${settingState.profile.telegraminvitelink}`,
                    setSwalProps,
                    intl
                  );
                } else {
                  CopyToClipboard(
                    `${settingState.profile.telegraminvitelink}`,
                    setSwalProps,
                    intl
                  );
                }
              }}
            />
          </div>
        )}
      </div>
      <div style={{ height: "10px" }}></div>
      <div
        style={{
          backgroundColor: "#1c1e23",
          width: "95%",
          margin: "0 auto",
          padding: "5px",
          display: "flex",
          borderRadius: "5px",
        }}
      >
        <div
          onClick={handleDepositClick}
          style={{
            height: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto auto",
            color: "white",
            textAlign: "center",
          }}
        >
          <div>
            <img
              src={toAbsoluteUrl("image/deposit2.avif?143243546")}
              alt="Deposit"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ fontSize: "10px" }}>
            {intl.formatMessage({ id: "deposit" })}
          </div>
        </div>

        <div
          onClick={handleTransferClick}
          style={{
            height: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto auto",
            color: "white",
            textAlign: "center",
          }}
        >
          <div>
            <img
              src={toAbsoluteUrl("image/transfer2.avif?75654312")}
              alt="Transfer"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ fontSize: "10px" }}>
            {intl.formatMessage({ id: "transfer" })}
          </div>
        </div>
        <div
          onClick={handleWithdrawClick}
          style={{
            height: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto auto",
            color: "white",
            textAlign: "center",
          }}
        >
          <div>
            <img
              src={toAbsoluteUrl("image/withdraw2.avif?21454654634")}
              alt="Withdraw"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ fontSize: "10px" }}>
            {intl.formatMessage({ id: "withdraw" })}
          </div>
        </div>
      </div>

      <div style={{ height: "10px" }}></div>
      <div
        style={{
          backgroundColor: "#1c1e23",
          width: "95%",
          margin: "0 auto",
          paddingTop: "5px",
          borderRadius: "5px",
        }}
      >
        {auth.bindagent === "true" && (
          <div
            onClick={handleRedirectToAgent}
            style={{
              height: "40px",
              width: "95%",
              display: "flex",
              alignItems: "center",
              margin: "0 auto",
              padding: "5px",
              color: "white",
            }}
          >
            <div style={{ flex: 2 }}>
              <img
                src={toAbsoluteUrl("/image/redirectagent.avif?4564654897")}
                alt="Redirect "
                style={{ width: "25px", height: "25px" }}
              />
            </div>
            <div style={{ flex: 7, fontSize: "10px" }}>
              {intl.formatMessage({ id: "redirecttoagent" })}
            </div>
            <div style={{ flex: 1 }}>
              <FiChevronRight />
            </div>
          </div>
        )}
        <div
          onClick={handlePersonalClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/information.avif?678236782")}
              alt="Personal"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "personal" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={openDialog}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/terms.avif?849589243")}
              alt="tnc"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "tnc" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={handleMemberTransferClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("image/membertransfer.avif?786234141")}
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "member_transfer" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={handleAddBankClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/bank.avif?67861843")}
              alt="Add Bank"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "bankCard" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={handleReportClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/report.avif?78953453")}
              alt="Report"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "report" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={handleTeamClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/team.avif?678932411")}
              alt="Report"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "team" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={handlePointShopClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "auto auto",
            padding: "5px",
            color: "white",
          }}
        >
          {showDialog && (
            <div className="dialogComing">
              <div className="dialogComing-content">
                <span className="text-font3" style={{ padding: "30px" }}>
                  {intl.formatMessage({ id: "comingSoon" })}
                </span>
                <div
                  className="text-font3 mt-3"
                  style={{ textAlign: "end", color: "#f5be09" }}
                  onClick={toggleDialog}
                >
                  {intl.formatMessage({ id: "close" })}
                </div>
              </div>
            </div>
          )}
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/pointshop.avif?6546242342")}
              alt="Point Shop"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "pointshop" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        <div
          onClick={handleBonusClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/bonus.avif?93247234")}
              alt="Bonus"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "bonus" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
        {/* {sessionStorage.getItem("platform") === "telegram" && (
          <>
            <div
              onClick={handleReferralClick}
              style={{
                height: "40px",
                width: "95%",
                display: "flex",
                alignItems: "center",
                margin: "0 auto",
                padding: "5px",
                color: "white",
              }}
            >
              <div style={{ flex: 2 }}>
                <img
                  src={toAbsoluteUrl("/image/redirectagent.png")}
                  alt="Bonus"
                  style={{ width: "25px", height: "25px" }}
                />
              </div>
              <div style={{ flex: 7, fontSize: "10px" }}>
                {intl.formatMessage({ id: "addReferral" })}
              </div>
              <div style={{ flex: 1 }}>
                <FiChevronRight />
              </div>
            </div>
          </>
        )} */}
      </div>
      {/* <div style={{ height: "10px" }}></div>
      <div
        style={{
          backgroundColor: "#1c1e23",
          width: "95%",
          margin: "0 auto",
          paddingTop: "5px",
          borderRadius: "5px",
        }}
      >
         <div
          onClick={handleContactUsClick}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          <div style={{ flex: 2 }}>
            <img
              src={toAbsoluteUrl("/image/contactus.png")}
              alt="Contact Us"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
          <div style={{ flex: 7, fontSize: "10px" }}>
            {intl.formatMessage({ id: "contact_us" })}
          </div>
          <div style={{ flex: 1 }}>
            <FiChevronRight />
          </div>
        </div>
      </div> */}

      <div style={{ height: "10px" }}></div>
      <div
        style={{
          backgroundColor: "#1c1e23",
          width: "95%",
          margin: "0 auto",
          paddingTop: "5px",
          borderRadius: "5px",
        }}
      >
        <div
          onClick={_showLanguage}
          style={{
            height: "40px",
            width: "95%",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            padding: "5px",
            color: "white",
          }}
        >
          {settingState.profile && settingState.profile.referralcode && (
            <>
              <div style={{ flex: 2 }}>
                {settingState.profile.language === "en" ? (
                  <img
                    src={toAbsoluteUrl("image/en.avif?78543534")}
                    style={{ width: "25px", height: "25px" }}
                    alt="English"
                  />
                ) : settingState.profile.language === "zh" ? (
                  <img
                    src={toAbsoluteUrl("image/cn.avif?67893435")}
                    style={{ width: "25px", height: "25px" }}
                    alt="Mandarin"
                  />
                ) : settingState.profile.language === "ms" ? (
                  <img
                    src={toAbsoluteUrl("image/my.avif?5756532")}
                    style={{ width: "25px", height: "25px" }}
                    alt="Mandarin"
                  />
                ) : (
                  <img
                    src={toAbsoluteUrl("image/id.avif?44654653")}
                    style={{ width: "25px", height: "25px" }}
                    alt="Malay"
                  />
                )}
              </div>

              <div style={{ flex: 7, fontSize: "10px" }}>
                {settingState.profile.language === "en"
                  ? intl.formatMessage({ id: "english" })
                  : settingState.profile.language === "zh"
                  ? intl.formatMessage({ id: "mandarin" })
                  : settingState.profile.language === "ms"
                  ? intl.formatMessage({ id: "malay" })
                  : intl.formatMessage({ id: "indo" })}
              </div>
              <div style={{ flex: 1 }}>
                <FiChevronRight />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ height: "20px" }}></div>
      <div
        className="text-font3"
        style={{ width: "95%", margin: "0 auto", paddingTop: "5px" }}
      >
        <button
          style={{
            backgroundColor: "#FF0000",
            color: "white",
            borderRadius: "5px",
            width: "100%",
            padding: "5px",
          }}
          onClick={handleLogout}
        >
          {intl.formatMessage({ id: "logout" })}
        </button>
      </div>
      <div style={{ height: "20px" }}></div>
      <Drawer
        anchor="bottom"
        open={openLanguage}
        onClose={handleCloseLanguage}
        style={{ minHeight: "40vh" }}
      >
        <div style={{ backgroundColor: "#1c1e23", padding: "16px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button onClick={handleCloseLanguage}>
              <FiArrowLeft style={{ color: "white" }} />
            </Button>
            <div style={{ flex: 7, color: "white" }} className="text-font4">
              {intl.formatMessage({ id: "choose_language" })}
            </div>
            <div style={{ flex: 2 }}></div>
          </div>

          <div
            style={{
              color: "white",
              cursor: "pointer",
              width: "100%",
              paddingTop: "20px",
            }}
            className="text-font3"
          >
            <div
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => handleLanguageChange("zh")}
            >
              <img
                src={toAbsoluteUrl("/image/cn.avif?8764323423")}
                style={{ width: "25px", height: "25px" }}
              />
              <div style={{ marginLeft: "20px" }}>
                {intl.formatMessage({ id: "mandarin" })}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => handleLanguageChange("en")}
            >
              <img
                src={toAbsoluteUrl("/image/en.avif?14353546756")}
                style={{ width: "25px", height: "25px" }}
              />
              <div style={{ marginLeft: "20px" }}>
                {intl.formatMessage({ id: "english" })}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => handleLanguageChange("ms")}
            >
              <img
                src={toAbsoluteUrl("/image/my.avif?6575623425")}
                style={{ width: "25px", height: "25px" }}
              />
              <div style={{ marginLeft: "20px" }}>
                {intl.formatMessage({ id: "malay" })}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => handleLanguageChange("id")}
            >
              <img
                src={toAbsoluteUrl("/image/id.avif?465464625423")}
                style={{ width: "25px", height: "25px" }}
              />
              <div style={{ marginLeft: "20px" }}>
                {intl.formatMessage({ id: "indo" })}
              </div>
            </div>
          </div>
        </div>
      </Drawer>
      <Dialog open={isDialogOpen} onClose={closeDialog}>
        <div
          style={{
            backgroundColor: "#1c1e23",
            color: "white",
            padding: "10px",
          }}
        >
          <div className="text-font4">{intl.formatMessage({ id: "tnc" })}</div>
          <div className="custom-border-bottom mb-2" />
          <div className="text-muted text-font2">
            <div className="fw-bold mb-2">
              {intl.formatMessage({ id: "userAgreement" })} :
            </div>
            <div className="mb-2">
              {intl.formatMessage({ id: "userAgreementDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "accountRegistration" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "accountRegistrationDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "accountRegistrationDscription_2" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "accountRegistrationDscription_3" })}
            </div>
            <div className="mb-2">
              {intl.formatMessage({ id: "accountRegistrationDscription_4" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "depositsNWithdrawals" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "depositsNWithdrawalsDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "depositsNWithdrawalsDscription_2" })}
            </div>
            <div className="mb-2">
              {intl.formatMessage({ id: "depositsNWithdrawalsDscription_3" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bettingRules" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bettingRulesDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bettingRulesDscription_2" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bettingRulesNoteTitle_1" })}
            </div>
            <div className="mb-1 d-flex">
              <i className="bi bi-dot"></i>
              {intl.formatMessage({ id: "bettingRulesNoteDscription_1" })}
            </div>
            <div className="mb-1 d-flex">
              <i className="bi bi-dot"></i>
              {intl.formatMessage({ id: "bettingRulesNoteDscription_2" })}
            </div>
            <div className="mb-1 d-flex">
              <i className="bi bi-dot"></i>
              {intl.formatMessage({ id: "bettingRulesNoteDscription_3" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bettingRulesNoteTitle_2" })}
            </div>
            <div className="mb-1 d-flex">
              <i className="bi bi-dot"></i>
              {intl.formatMessage({ id: "bettingRulesNoteDscription_4" })}
            </div>
            <div className="mb-1 d-flex">
              <i className="bi bi-dot"></i>
              {intl.formatMessage({ id: "bettingRulesNoteDscription_5" })}
            </div>
            <div className="mb-2 d-flex">
              <i className="bi bi-dot"></i>
              {intl.formatMessage({ id: "bettingRulesNoteDscription_6" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bonusesNPromotions" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bonusesNPromotionsDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "bonusesNPromotionsDscription_2" })}
            </div>
            <div className="mb-2">
              {intl.formatMessage({ id: "bonusesNPromotionsDscription_3" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "playResponsibly" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "playResponsiblyDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "playResponsiblyDscription_2" })}
            </div>
            <div className="mb-2">
              {intl.formatMessage({ id: "playResponsiblyDscription_3" })}
            </div>
            <div className="mb-1">{intl.formatMessage({ id: "others" })}</div>
            <div className="mb-1">
              {intl.formatMessage({ id: "othersDscription_1" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "othersDscription_2" })}
            </div>
            <div className="mb-1">
              {intl.formatMessage({ id: "othersDscription_3" })}
            </div>
            <div className="mb-3">
              {intl.formatMessage({ id: "othersDscription_4" })}
            </div>
          </div>
          <div
            className="text-font2"
            onClick={closeDialog}
            style={{
              width: "30%",
              backgroundColor: "#f5be09",
              border: "1px solid #f5be09",
              margin: "0 auto",
              borderRadius: "5px",
              textAlign: "center",
            }}
          >
            <div style={{ padding: "5px", color: "black" }}>
              {intl.formatMessage({ id: "close" })}
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog open={open} onClose={handleClose}>
        <div
          className="text-font3"
          style={{
            padding: "20px",
            backgroundColor: "#1c1e23",
            color: "white",
          }}
        >
          <p> {intl.formatMessage({ id: "openNewRedirectTab" })}</p>
          <div
            style={{ color: "#f5be09", textAlign: "end" }}
            onClick={handlNew}
          >
            {intl.formatMessage({ id: "confirm" })}
          </div>
        </div>
      </Dialog>
    </div>
  );
};
